import {createApi} from '@reduxjs/toolkit/query/react';

import baseQuery from '../helpers/BaseQuery';
import {createQueryParams} from '../helpers/Utils';

// Define a service using a base URL and expected endpoints
const docViewerAPI = createApi({
  reducerPath: 'enrollAPI',
  baseQuery,
  tagTypes: ['api'],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getDocument: builder.query({
      query: (params) => `v1/document/?${createQueryParams(params)}`,
      invalidatesTags: ['api'],
    }),
    postPin: builder.mutation({
      query: (body) => ({
        url: `v1/pin/send`,
        method: 'POST',
        body: body,
      }),
      // Pick out data and prevent nested properties in a hook or selector
      // transformResponse: (response, meta, arg) => response.data,
      invalidatesTags: ['api'],
    }),
    getDocuments: builder.query({
      query: (params) => `v1/documents/?${createQueryParams(params)}`,
      invalidatesTags: ['api'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useLazyGetDocumentQuery,
  usePostPinMutation,
  useLazyGetDocumentsQuery,
} = docViewerAPI;

export default docViewerAPI;
